"use client";

import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import Input from "@client/components/formik/input";

interface Props {
  autoComplete?: string;
  id: string;
  name: string;
}

export default function PasswordInput({ autoComplete, id, name }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <Input
        autoComplete={autoComplete}
        id={id}
        name={name}
        type={isVisible ? "text" : "password"}
      />
      <button
        aria-label={isVisible ? "Hide password" : "Show password"}
        aria-pressed={isVisible}
        className="auth-field__toggle"
        data-spec="password-toggle"
        onClick={() => setIsVisible(!isVisible)}
        type="button"
      >
        <FontAwesomeIcon icon={isVisible ? faEyeSlash : faEye} />
      </button>
    </>
  );
}
